module.exports = __webpack_public_path__ + "img/enSucc.5c029889.png";